import type { TranslateFunction } from "../types/i18n";

const formatDate = (date: unknown): string => {
  if (!date) return "\u2014";
  const d = new Date(date as string);
  return isNaN(d.getTime()) ? "\u2014" : d.toLocaleDateString("bs-BA", { day: "2-digit", month: "2-digit", year: "numeric" });
};

const formatCurrency = (amount: unknown, fallback = "0.00 KM"): string => {
  if (amount === null || amount === undefined) return fallback;
  const n = typeof amount === "number" ? amount : Number(amount);
  return isNaN(n) ? fallback : `${n.toFixed(2)} KM`;
};

const formatAmount = (amount: unknown): string => formatCurrency(amount, "\u2014");

const nowTimeString = (): string => new Date().toLocaleTimeString();

const MS_PER_DAY = 86_400_000;
const EMPTY_VALUE = "—";

const toDate = (value: unknown): Date | null => {
  if (!value) return null;
  const d = value instanceof Date ? value : new Date(value as string);
  return isNaN(d.getTime()) ? null : d;
};

const daysBetween = (from: unknown, to: unknown): number | null => {
  const start = toDate(from);
  const end = toDate(to);
  if (!start || !end) return null;
  return Math.round((end.getTime() - start.getTime()) / MS_PER_DAY);
};

const daysSince = (value: unknown): number | null => daysBetween(value, new Date());

const formatDayCount = (days: number | null, t: TranslateFunction): string => {
  if (days === null) return EMPTY_VALUE;
  if (days <= 0) return t("invoiceDetail:today");
  return t("invoiceDetail:daysCount", { count: days });
};

const formatLogTime = (value?: string | number | Date): string => {
  const d = value ? new Date(value) : new Date(NaN);
  return isNaN(d.getTime()) ? nowTimeString() : d.toLocaleTimeString();
};

const parseDecimalInput = (raw: string): number | null => {
  const normalized = raw.replace(",", ".").trim();
  if (!normalized) return null;
  const value = Number(normalized);
  return Number.isFinite(value) && value >= 0 ? value : null;
};

const isDecimalInputValid = (value: string): boolean => /^\d{0,10}([.,]\d{0,2})?$/.test(value);

export {
  formatDate,
  formatCurrency,
  formatAmount,
  formatLogTime,
  parseDecimalInput,
  isDecimalInputValid,
  daysBetween,
  daysSince,
  formatDayCount,
  toDate,
};
